import * as React from "react";

function SvgPlay(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -9 34 34" width={25.211} height={25.059} {...props}>
        <path
          d="M11.988 0a11.909 11.909 0 00-8.477 3.511A11.911 11.911 0 000 11.989a11.91 11.91 0 003.511 8.477 11.91 11.91 0 008.477 3.511 11.911 11.911 0 008.478-3.511 11.909 11.909 0 003.511-8.477 11.911 11.911 0 00-3.511-8.478A11.911 11.911 0 0011.988 0zm0 22.291a10.239 10.239 0 01-4.009-.808A10.3 10.3 0 014.7 19.277a10.24 10.24 0 01-2.2-3.278 10.227 10.227 0 01-.81-4.01 10.239 10.239 0 01.804-4.012A10.31 10.31 0 014.7 4.704a10.238 10.238 0 013.278-2.207 10.211 10.211 0 014.01-.81A10.239 10.239 0 0116 2.494a10.327 10.327 0 013.276 2.208 10.246 10.246 0 012.204 3.275 10.22 10.22 0 01.81 4.011 10.239 10.239 0 01-.807 4.009 10.319 10.319 0 01-2.208 3.28 10.247 10.247 0 01-3.275 2.2 10.235 10.235 0 01-4.012.814zM9.861 5.949a.835.835 0 00-.615.266.838.838 0 00-.228.6.837.837 0 00.265.588l4.864 4.559-4.865 4.565a.836.836 0 00-.266.587.837.837 0 00.228.6.834.834 0 00.614.266.841.841 0 00.577-.229l5.522-5.174a.844.844 0 00.267-.616.84.84 0 00-.265-.614l-5.521-5.17a.841.841 0 00-.577-.228z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgPlay;
